import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { StarRow } from "@/components/StarRow";
import { api } from "@/lib/api";

export function AppRatingBadge() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/app-reviews/summary").then((r) => setS(r.data)).catch(() => {}); }, []);
  if (!s?.count) return null;
  return (
    <Link to="/app-reviews" data-testid="app-rating-badge" className="rise inline-flex items-center gap-2 mt-6 rounded-full bg-[#151C2C]/80 border border-[#26334D] px-4 py-2 text-sm hover:border-[#FFB800] transition-colors">
      <StarRow value={s.average} /> <span className="font-bold">{s.average.toFixed(1)}</span>
      <span className="text-slate-400">from {s.count} traveler {s.count === 1 ? "rating" : "ratings"} · Read reviews</span>
    </Link>
  );
}
